(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('expense', {
            parent: 'entity',
            url: '/expense?page&sort&search',
            data: {
                authorities: ['ROLE_BUDGET_READ_ONLY','ROLE_BUDGET_EDIT'],
                pageTitle: 'wamasysApp.expense.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/expense/expenses.html',
                    controller: 'ExpenseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('expense');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('expense-detail', {
            parent: 'entity',
            url: '/expense/{id}',
            data: {
                authenticate: true,
                authorities: ['ROLE_BUDGET_READ_ONLY','ROLE_BUDGET_EDIT'],
                pageTitle: 'wamasysApp.expense.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/expense/expense-detail.html',
                    controller: 'ExpenseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('expense');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Expense', function($stateParams, Expense) {
                    return Expense.get({id : $stateParams.id});
                }]
            }
        })
        .state('expense.new', {
            parent: 'expense',
            url: '/new',
            data: {
        		authorities: ['ROLE_BUDGET_EDIT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/expense/expense-dialog.html',
                    controller: 'ExpenseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('expense', null, { reload: true });
                }, function() {
                    $state.go('expense');
                });
            }]
        })
        .state('expense.edit', {
            parent: 'expense',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_BUDGET_EDIT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/expense/expense-dialog.html',
                    controller: 'ExpenseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Expense', function(Expense) {
                            return Expense.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('expense', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('expense.delete', {
            parent: 'expense',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_BUDGET_EDIT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/expense/expense-delete-dialog.html',
                    controller: 'ExpenseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Expense', function(Expense) {
                            return Expense.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('expense', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
